import React from 'react';
import { Link } from "react-router-dom";
import { useInView } from 'react-intersection-observer';
import { 
  FaFileSignature, 
  FaGlobe, 
  FaHandshake, 
  FaGavel, 
  FaLaptopCode, 
  FaChartLine, 
  FaIndustry, 
  FaRocket, 
  FaHome 
} from 'react-icons/fa';
import './services.css';
import HeroFooter from '../components/footer';

const offeringsData = [
  {
    icon: <FaFileSignature />,
    title: "Contract Management",
    description: "End-to-end contract lifecycle management with AI-powered insights. Streamline agreements and mitigate legal risks.",
    link: "/contract"
  },
  {
    icon: <FaGlobe />,
    title: "Foreign Collaborations",
    description: "Facilitating cross-border partnerships with global expertise. We help navigate regulatory landscapes and foster lasting international alliances.",
    link: "/foreign"
  },
  {
    icon: <FaHandshake />,
    title: "Joint Ventures",
    description: "Coordinating strategic alliances and joint ventures. Our expert guidance helps align partners’ interests and maximize synergistic growth.",
     link: "/joint"
  },
  {
    icon: <FaGavel />,
    title: "Corporate Law",
    description: "Providing in-depth advisory on corporate legal matters, including governance, compliance, and regulatory frameworks to safeguard your business.",
     link: "/corporate"
  },
  {
    icon: <FaLaptopCode />,
    title: "Information Technology",
    description: "Leveraging tech-driven legal solutions to support digital transformations. Our services cover IT compliance, cybersecurity, and tech licensing.",
     link: "/information"
  },
  {
    icon: <FaChartLine />,
    title: "Business Ventures",
    description: "Empowering growth through strategic legal advisory for new business ventures. From startups to scaling operations, we guide your journey to success.",
     link: "/buisness"
  },
  {
    icon: <FaIndustry />,
    title: "MSME",
    description: "Dedicated legal support for Micro, Small, and Medium Enterprises. We help navigate funding challenges, regulatory compliance, and business expansion.",
     link: "/msme"
  },

  {
    icon: <FaRocket />,
    title: "Start-up India Initiatives",
    description: "Accelerating innovation with comprehensive legal support under the Start-up India initiative. We provide strategic guidance for emerging entrepreneurs.",
     link: "/startup"
  },
  {
    icon: <FaHome />,
    title: "Property and Real Estate",
    description: "Expert counsel for property transactions and real estate matters. Our services cover acquisitions, contract negotiation, and regulatory compliance.",
    link: "/realestate"
  }
];

const OfferingCard = ({ icon, title, description, index, link }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
 
    <div 
      ref={ref}
      className={`offering-card ${inView ? 'animate' : ''}`}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <div className="card-icon">{icon}</div>
      <h3>{title}</h3>
      <p>{description}</p>
      <br/>
      <Link to={link} className="consult-button" >
  Read More...
</Link>
    </div>
  );
};

const Services = () => {
  return (
    <div>
    <div className="offerings-page">
      <div className="about-heading">Our Offering</div>
      <section className="offerings-grid">
        {offeringsData.map((offering, index) => (
          <OfferingCard key={index} index={index} {...offering} />
        ))}
        
      </section>
      </div>
      <HeroFooter/>
    </div>

  );
};

export default Services;
